<template>
  <div class="AContainer">
    <a-table
      :columns="SummaryColumns"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="false"
      :data-source="TableData"
      rowKey="chatSummaryId"
      :scroll="{ y: 'calc(100vh - 400px)', x: '100%' }"
    >
      <template #contents="{ record, text: contents }">
        <a-tooltip
          v-if="record.type !== 1"
          color="#fff"
          overlayClassName="aaaaa"
          placement="bottomLeft"
        >
          <template #title>
            <span :style="{ fontSize: '14px', color: '#333333' }">
              {{ contents }}
            </span>
          </template>
          <div class="contents">{{ contents }}</div>
        </a-tooltip>
        <span v-else>--</span>
      </template>
      <template #workOrderIds="{ text: workOrderIds }">
        <div v-if="workOrderIds && workOrderIds.length">
          <span v-for="(item, index) in workOrderIds" :key="index">
            <a class="link" @click="viewDetails(item)">{{ item }}</a>
            <span v-if="index !== workOrderIds.length - 1">、</span>
          </span>
        </div>
        <span v-else>--</span>
      </template>
      <template #pushStatus="{ text: pushStatus }">
        <span>{{ pushStatus ? '是' : '否' }}</span>
      </template>
      <template #operation="{ record }">
        <a style="margin-right: 20px" @click="rowDetail(record)">查看详情</a>
        <!--
          NOTE: 只有 0 是人工小结，1是导诊结果。 其余的都是AI完成的小结（不能编辑）
          record.type :
            GUIDE_RESULT_TYPE(1, "导诊结果"),
            PRESCRIPTION_WAIT_BUY(2, "处方待购"),
            AI_GUIDE_CONSULT(3, "AI引导问诊小结"),
            CHAT_FOLLOWUP_TASK(4,"复诊跟踪"),
            CHAT_FOLLOWUP_REMIND(5,"复诊提醒"),
            CHAT_PATIENT_PRIVATE(6,"患者私聊"),
            CHAT_FOLLOWUP_DATE_DISAGREE(7,"复诊日期不同意"),
            CHAT_SUPPLEMENT_MEDICAL(8,"填写诊断及复诊日期")
        -->
        <!-- <a
          v-if="
            (mode !== 'read' && [0, 1].includes(record.type)) ||
            (record.type === 10 && record.createBy === store.getters.userId)
          "
          @click="edit(record)"
        >
          编辑
        </a> -->
        <a v-if="hasEdit(record)" @click="edit(record)">编辑</a>
      </template>
    </a-table>
    <a-row type="flex" justify="end" style="margin-top: 20px">
      <a-col>
        <a-pagination
          v-if="Total"
          show-size-changer
          show-quick-jumper
          v-model:current="current"
          v-model:pageSize="pageSize"
          :total="Total"
          @change="listquery"
          @showSizeChange="listquery"
          :show-total="total => `共${Total}条`"
        />
      </a-col>
    </a-row>
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <summaryPannel :chatSummaryId="chatSummaryId" @closeSummaryModal="closeSummaryModal" />
    </a-modal>
    <EditSummary ref="editSummaryRef" @changeTab="listquery" />
    <!-- 关联工单 -->
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, defineProps, defineEmits } from 'vue'
import { SummaryColumns } from '@/constants/columns'
import { getCurSummaryList, getSummaryInfo } from '@/api/workPlace/summary'
import summaryPannel from '../chat/components/summaryPannel/index.vue'
import { useStore } from 'vuex'
import EditSummary from './editSummary.vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { workOrderDetail } from '@/api/Todo/index.js'

const editSummaryRef = ref(null)
const emits = defineEmits(['closeSummaryModal'])
const store = useStore()
const props = defineProps({
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  },
  workOrderId: {
    type: String,
    default: ''
  },
  businessType: {
    type: Number,
    default: null
  },
  isComponent: { type: Boolean, default: false }
})
const summaryPanelVisible = ref(false)
const Total = ref(0)
const current = ref(1)
const pageSize = ref(10)
const TableData = ref([])
const chatSummaryId = ref('')
// 是否展示 编辑按钮
const hasEdit = record => {
  let is = false
  // 只读状态
  if (props.mode === 'read') return false
  // 0 是人工小结，1是导诊结果。
  if ([0, 1].includes(record.type)) {
    is = true
  }
  // 自己修改的可编辑
  else if (record.type === 10 && record.createBy === store.getters.userId) {
    is = true
  }
  // ai 编辑的可以修改
  else if (record.isAiCallOut && record.createBy === 0) {
    return true
  }
  return is
}
const ucPatientId = computed(() => {
  return props?.ucUserId || store?.state?.workOrder?.workOrderGroupInfo?.patientInfo?.ucUserId || ''
})
const listquery = async () => {
  const query = reactive({
    currPage: current.value,
    pageSize: pageSize.value,
    ucPatientId: ucPatientId.value
  })
  const { list, totalCount } = await getCurSummaryList(query)
  Total.value = totalCount
  TableData.value = list
}

onMounted(() => {
  listquery()
})

const rowDetail = record => {
  chatSummaryId.value = record.chatSummaryId
  summaryPanelVisible.value = true
}

const curWorkOrderInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const dealWorkOrderId = computed(() => {
  return props.workOrderId || curWorkOrderInfo.value.targetWorkOrder.workOrderId
})

const edit = record => {
  getSummaryInfo({ chatSummaryId: record.chatSummaryId }).then(res => {
    const params = {
      privateId: res.groupId,
      groupInfo: res,
      isEdit: true,
      type: res.type,
      aiSummaryContents: res.type === 1 ? JSON.parse(res.contents) : res.content,
      workOrderId: dealWorkOrderId.value
    }
    editSummaryRef.value?.initModal(params)
  })
}

function closeSummaryModal() {
  summaryPanelVisible.value = false
  emits('closeSummaryModal')
}

const showAllDialog = ref(false)
const currentInfo = ref({})
const viewDetails = workOrderId => {
  workOrderDetail({ workOrderId }).then(res => {
    const { workOrder = {} } = res || {}
    showAllDialog.value = true
    currentInfo.value = workOrder
  })
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}
</script>

<style lang="scss" scoped>
.AContainer {
  padding: 20px;
}
.contents {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
